module.exports = __webpack_public_path__ + "static/sport/tag-regist-active.410fc41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport8/tag-regist-active.png
// module id = TlF0
// module chunks = 0